import { gql } from '@common/hooks';

export const SidebarQuery = gql`
  query SidebarQuery {
    menu @client {
      active
    }
  }
`;

export type SidebarQueryResponse = {
  menu: {
    active: string;
  };
};
